'use strict';

var React = require('react');
var SVTLink = require('../elements/SVTLink');

module.exports = React.createClass({

	displayName: 'LinkButton',

	propTypes: {
		url: React.PropTypes.string,
		program: React.PropTypes.object,
		theme:  React.PropTypes.string,
		state: React.PropTypes.string,
		isSelected: React.PropTypes.bool,
		modifiers: React.PropTypes.oneOfType([
			React.PropTypes.string,
			React.PropTypes.array
		]),
		icon: React.PropTypes.oneOfType([
			React.PropTypes.string,
			React.PropTypes.array
		])
	},

	_childRender: function (childs,icon) {

		if(!icon ){
			return childs;
		}

		icon = [].concat(icon);

		var animatable = "";
		if(icon[2]){
			animatable = " svt_icon svt_icon--animatable";
		}

		var classes = "svt_icon" + animatable + " svt_icon--" + icon[0];

		if(icon.length > 1 &&  icon[1] === "after"){
			return <span>{childs} <i className={classes}></i></span>;
		} else {
			return <span><i className={classes}></i> {childs}</span>;
		}
	},


	render: function () {

		var {url, program, children, theme, state, modifiers, icon, isSelected, ...other } = this.props;


		if(!url && program && program.id){
			url = '/' + program.id;
		}


		if (!(url || children)) {
			return false;
		}

		var cssClasses = "svtse_button", themeClass = "";

		if(icon && icon[2]){
			cssClasses += " svtse_button--animated-icon";
		}

		if(theme){
			themeClass = "--theme-" + theme;
			cssClasses += " svtse_button" + themeClass;
		}

		if(state){
			cssClasses += " svtse_button" + themeClass + "--" + state;
		}

		if(isSelected){
			cssClasses += " svtse_button" + themeClass + "--selected";
		}

		if(modifiers){
			[].concat(modifiers).forEach(function(modifier){
				cssClasses += " svtse_button--" + modifier;
			});
		}


		// TODO: This might be the only way to handle this right now
		return (
			<SVTLink to={url} className={cssClasses} {...other} >
				{this._childRender(children, icon)}
			</SVTLink>
		);

	}
});



/** WEBPACK FOOTER **
 ** ./app/components/elements/LinkButton.jsx
 **/